// Configuração do Marketplace de marcenarias parceiras.
//
// Cada cidade/região da MINI é atendida por uma marcenaria:
//   JP     → Arco (interno — NÃO entra no marketplace)
//   CG     → Piemonte
//   NATAL  → Domoby
//   RECIFE → Cobalto
//
// Divisão financeira: parceiro recebe 78% do valor total (móveis + frete),
// MINI fica com 22%. Pagamento é NA ENTREGA — pedidos não entregues são
// "previstos" pra pagamento futuro.

import { detectarCidadeAba } from './kanban'

// Percentual pro parceiro (do valor total do pedido, móveis + frete)
export const PARCEIRO_PCT = 0.78

// Definição dos parceiros — id, nome, cidade-aba do MINI e cor UI.
export const PARCEIROS = [
  { id: 'piemonte', nome: 'Piemonte', cidade: 'CG',     cor: '#F5C200', bg: '#FFF9C2' },
  { id: 'domoby',   nome: 'Domoby',   cidade: 'NATAL',  cor: '#3B82F6', bg: '#DBEAFE' },
  { id: 'cobalto',  nome: 'Cobalto',  cidade: 'RECIFE', cor: '#8B5CF6', bg: '#EDE9FE' },
]

// Retorna o parceiro do pedido baseado na cidade detectada. Retorna null
// pra JP (interno = Arco) e "OUTRAS" (sem parceiro definido).
export function parceiroDoPedido(pedido) {
  const aba = detectarCidadeAba(pedido)
  return PARCEIROS.find(p => p.cidade === aba) || null
}

// Calcula os valores financeiros de um pedido pro Marketplace.
// Base do cálculo: móveis (p.valorTotal, já com desconto se houver) + frete.
export function calcularFinanceiro(pedido) {
  const moveis = Number(pedido?.valorTotal) || 0
  const frete  = Number(pedido?.frete)      || 0
  const total  = moveis + frete
  const parceiro = Math.round(total * PARCEIRO_PCT * 100) / 100
  const mini     = Math.round(total * (1 - PARCEIRO_PCT) * 100) / 100
  return { moveis, frete, total, parceiro, mini }
}

// Status de pagamento de um pedido no Marketplace:
//   'previsto' — não entregue ainda, valor a pagar depois da entrega
//   'a_pagar'  — entregue, parceiro ainda não recebeu
//   'pago'     — marcado como pago pelo gerente
export function statusMarketplace(pedido, pagamentos) {
  const isPago = !!pagamentos?.[pedido.id]?.pago
  if (isPago) return 'pago'
  const entregue = pedido.status === 'ENTREGUE' || pedido.status === 'POS_VENDA'
  return entregue ? 'a_pagar' : 'previsto'
}
